const BASE_URL = "https://app.citygroupbd.com";
const ESALE_URL = "https://esale.citygroupbd.com";
const MIS_URL = "https://mis.citygroupbd.com";

export const NAV_ITEMS = [
  // { name: "Home", url: `${BASE_URL}/` },
  //  { name: "Services", url: `${BASE_URL}/services` },
  //  { name: "Downloads", url: `${BASE_URL}/downloads` },
  // { name: "Contact", url: `${BASE_URL}/contact` },
];

export const DEFAULT_NAV_ITEM = "Home";

export const APP_CONFIGS = [
  // Row 1
  {
    id: "employee-portal",
    icon: "/images/icons/icon_and_background/1.png",
    title: "Employee Portal",
    subtitle: "HR Management",
    bgColor: "bg-gradient-to-br from-emerald-500 to-emerald-600",
    color: "text-emerald-100",
    category: "hr",
    url: `${BASE_URL}/portal/v_1401232042/index.html#/login`,
  },
  {
    id: "advanced-erp",
    icon: "/images/icons/icon_and_background/2.png",
    title: "Advanced ERP",
    subtitle: "Financial approvals,reporting",
    bgColor: "bg-gradient-to-br from-purple-400 to-purple-500",
    color: "text-purple-100",
    category: "erp",
    url: `${BASE_URL}/advancederp`,
  },
  {
    id: "scm-web",
    icon: "/images/icons/icon_and_background/3.png",
    title: "SCM Web",
    subtitle: "Supply Chain",
    bgColor: "bg-gradient-to-br from-yellow-500 to-orange-500",
    color: "text-yellow-100",
    category: "supply-chain",
    url: `${BASE_URL}/scmweb/scmweb_060420231524/index.html#/login`,
  },
  {
    id: "sales-web",
    icon: "/images/icons/icon_and_background/4.png",
    title: "Sales Web",
    subtitle: "Sales & Marketing",
    bgColor: "bg-gradient-to-br from-rose-400 to-pink-500",
    color: "text-rose-100",
    category: "sales",
    url: `${BASE_URL}/salesweb`,
  },

  // Row 2
  {
    id: "lc-management",
    icon: "/images/icons/icon_and_background/5.png",
    title: "LC Management System",
    subtitle: "Letter of Credit",
    bgColor: "bg-gradient-to-br from-sky-400 to-blue-500",
    color: "text-sky-100",
    category: "finance",
    url: `${BASE_URL}/LCMS`,
  },
  {
    id: "mis-portal",
    icon: "/images/icons/icon_and_background/6.png",
    title: "MIS Portal",
    subtitle: "MIS Reporting",
    bgColor: "bg-gradient-to-br from-lime-500 to-green-600",
    color: "text-lime-100",
    category: "reporting",
    url: `https://mis.citygroupbd.com/MISReport/Account/Login`,
  },
  {
    id: "property-management",
    icon: "/images/icons/icon_and_background/7.png",
    title: "Property Management",
    subtitle: "Real Estate",
    bgColor: "bg-gradient-to-br from-orange-400 to-orange-500",
    color: "text-orange-100",
    category: "property",
    url: `${MIS_URL}/pmis`,
  },
  {
    id: "distribution-portal",
    icon: "/images/icons/icon_and_background/8.png",
    title: "Distribution Portal",
    subtitle: "Logistics",
    bgColor: "bg-gradient-to-br from-red-500 to-red-600",
    color: "text-red-100",
    category: "logistics",
    url: `${MIS_URL}/cssapbackoffice/cssap_1701232022/index.html#/login`,
  },

  // Row 3
  {
    id: "land-management",
    icon: "/images/icons/icon_and_background/9.png",
    title: "Land Management System",
    subtitle: "Land Assets",
    bgColor: "bg-gradient-to-br from-cyan-500 to-blue-600",
    color: "text-cyan-100",
    category: "property",
    url: `${BASE_URL}/lms`,
  },
  {
    id: "event-management",
    icon: "/images/icons/icon_and_background/11.png",
    title: "e-MarCom Central (MCC)",
    subtitle: "Event management",
    bgColor: "bg-gradient-to-br from-amber-400 to-orange-500",
    color: "text-amber-100",
    category: "operations",
    url: `${BASE_URL}/speechbubble`,
  },
  {
    id: "tea-estate-management",
    icon: "/images/icons/icon_and_background/10.png",
    title: "Tea Estate Management",
    subtitle: "Tea gardens management",
    bgColor: "bg-gradient-to-br from-orange-500 to-red-500",
    color: "text-orange-100",
    category: "agriculture",
    url: `${BASE_URL}/teamgt`,
  },
  {
    id: "pos",
    icon: "/images/icons/icon_and_background/12.png",
    title: "POS",
    subtitle: "Point of Sale",
    bgColor: "bg-gradient-to-br from-gray-500 to-gray-600",
    color: "text-gray-100",
    category: "retail",
    url: `${BASE_URL}/pos`,
  },

  // Row 4
  {
    id: "rfq",
    icon: "/images/icons/icon_and_background/13.png",
    title: "RFQ/e-Tender",
    subtitle: "Request for Quotation",
    bgColor: "bg-gradient-to-br from-green-500 to-emerald-600",
    color: "text-green-100",
    category: "procurement",
    url: `${BASE_URL}/rfq`,
  },
  {
    id: "assettracking",
    icon: "/images/icons/icon_and_background/17.png",
    title: "Asset Management",
    subtitle: "Asset tracking management",
    bgColor: "bg-gradient-to-br from-green-500 to-emerald-600",
    color: "text-green-100",
    category: "procurement",
    url: `${BASE_URL}/assetmanagement`,
  },
  {
    id: "e-recruitment",
    icon: "/images/icons/icon_and_background/15.png",
    title: "e-Recruitment Portal",
    subtitle: "Hiring Process",
    bgColor: "bg-gradient-to-br from-indigo-400 to-purple-500",
    color: "text-indigo-100",
    category: "hr",
    url: `${BASE_URL}/erecruitment`,
  },
  {
    id: "e-commerce",
    icon: "/images/icons/icon_and_background/14.png",
    title: "e-Commerce (esale)",
    subtitle: "Online Store",
    bgColor: "bg-gradient-to-br from-yellow-500 to-amber-600",
    color: "text-yellow-100",
    category: "retail",
    url: `${ESALE_URL}`,
  },
  {
    id: "navigation",
    icon: "/images/icons/icon_and_background/18.png",
    title: "Navigation",
    subtitle: "Navigation System",
    bgColor: "bg-gradient-to-br from-pink-400 to-rose-500",
    color: "text-pink-100",
    category: "communication",
    url: `${BASE_URL}/navigation`,
  },
  {
    id: "web-mail",
    icon: "/images/icons/icon_and_background/16.png",
    title: "Web Mail",
    subtitle: "Email System",
    bgColor: "bg-gradient-to-br from-pink-400 to-rose-500",
    color: "text-pink-100",
    category: "communication",
    url: `https://mail.citygroupbd.com/owa`,
  },
];

export const APP_CATEGORIES = {
  ALL: "all",
  HR: "hr",
  ERP: "erp",
  SALES: "sales",
  FINANCE: "finance",
  PROPERTY: "property",
  RETAIL: "retail",
};
